import Tokenfield from "tokenfield";

const S2SIPSEC_MAX_REMOTE_SITES_COUNT = 10;
const S2SIPSEC_FIELDS_TO_CLEAN = ['name', 'public_ip', 'remote_ip', 'remote_name'];
const S2SIPSEC_REMOTE_ID_TYPE_IP = 'ip';

const addRemoteIdToggleHandler = $element => {
  $element.find('.remote-id [type=radio]').click(function () {
    const $this = $(this);
    $this.parents('[remote-id]').attr('remote-id', this.value);
    const $remoteIdBlock = $this.parents('.remote-id'),
        $remoteIpInput = $remoteIdBlock.find('.js-remote-ip'),
        $remoteNameInput = $remoteIdBlock.find('.js-remote-name');
    if (this.value === 'ip') {
      $remoteNameInput.prop('disabled', true);
      $remoteIpInput.val($this.parents('.ipsec-site.record').find('input.js-public-ip').val());
      $remoteNameInput.data('last-input', $remoteNameInput.val());
      $remoteNameInput.val('');
    } else {
      $remoteNameInput.prop('disabled', false);
      $remoteNameInput.val($remoteNameInput.data('last-input'));
      $remoteIpInput.val('');
    }
  });
};

const createTokenField = function (selector, items, itemName, maxItems, scope = document) {
  new Tokenfield({
    el: scope.querySelector(selector),
    addItemOnBlur: true,
    maxItems: maxItems,
    placeholder: '1.1.1.1/n',
    delimiters: [','],
    setItems: items,
    itemName: itemName,
    newItemName: itemName
  });
};

const initS2SIPSec = ($editForm, data, options) => {
  const $addRemoteSiteButton = $editForm.find('#add-remote-site a');

  const toggleDeleteSiteButtonVisibility = () => {
    const $deleteButtons = $editForm.find('#s2sipsec-remote-sites .js-delete-site');
    if ($editForm.find('#s2sipsec-remote-sites .ipsec-site.record').length > 1) {
      $deleteButtons.show();
    } else {
      $deleteButtons.hide();
    }
  };

  const onRemoteSiteDeleteClick = function () {
    this.closest('.ipsec-site.record').remove();
    toggleDeleteSiteButtonVisibility();
    toggleAddNewRemoteSiteButtonVisibility();
  };

  const addPublicIpChanges = function ($element, recordNum) {
    $element.find(`.form-control.js-public-ip[name="public_ip[${recordNum}]"]`).on('input keyup', function () {
      const $jsSiteId = $(this).parents('.js-site-id');
      if ($jsSiteId.find('.row.remote-id').attr('remote-id') === S2SIPSEC_REMOTE_ID_TYPE_IP) {
        $jsSiteId.find('.js-remote-ip').val(this.value);
      }
    });
  };

  const initFields = () => {
    for (let i in data.remoteSites) {
      const items = [];
      for (let subnet of data.remoteSites[i][options.subnetsName]) {
        items.push({id: subnet, name: subnet});
      }
      const tokenfieldSelector = `.ipsec-site.record[data-num="${i}"] .js-remote-subnets-tokenfield`;
      createTokenField(tokenfieldSelector, items, `remote_subnets[${i}]`, data.subnetsLimit, $editForm[0]);
      addPublicIpChanges($editForm, i);
    }
  };

  const toggleAddNewRemoteSiteButtonVisibility = () => {
    if ($editForm.find('.ipsec-site.record').length < S2SIPSEC_MAX_REMOTE_SITES_COUNT) {
      $addRemoteSiteButton.removeClass('invisible');
    }
    else {
      $addRemoteSiteButton.addClass('invisible');
    }
  };

  const addNewSite = function () {
    if ($editForm.find('.ipsec-site.record').length >= S2SIPSEC_MAX_REMOTE_SITES_COUNT) {
      return;
    }
    const lastRecord = $editForm.find('.ipsec-site.record:last'),
        newRecord = lastRecord.clone(true),
        newRecordNum = lastRecord.data('num') + 1;
    newRecord.data('num', newRecordNum);
    newRecord.attr('data-num', newRecordNum.toString());
    newRecord.find('.form-group input').removeClass('field-error');
    newRecord.find('.form-group span.error').remove();
    newRecord.find('[data-axtooltip-class="error"]').remove()
    newRecord.find('.ipsec-title span').text('New Remote Site ' + newRecordNum);
    newRecord.find('.record-radio .value').each(function () {
      const $this = $(this),
          currentId = $this.find('input:radio').attr('id'),
          newId = currentId.replace(/-[0-9]*$/g, '-' + newRecordNum.toString());
      $this.find('input:radio').attr('id', newId);
      $this.find('label').attr('for', newId);
    });

    newRecord.find('input:not(.tokenfield-copy-helper):not(.tokenfield-input)').each(function () {
      const $this = $(this),
          baseName = $this.attr('name').replace(/\[.+/, ''),
          newName = baseName + '[' + newRecordNum + ']';
      $this.attr('name', newName);
      if (S2SIPSEC_FIELDS_TO_CLEAN.indexOf(baseName) !== -1) {
        $this.val('');
      }
      $this.attr('data-name', 'advanced_settings[s2s_ipsec][remote_sites][' + newRecordNum + '][' + baseName + ']');

      if ($this.hasClass('js-remote-subnets-tokenfield')) {
        newRecord.find('.remote-subnets').children().remove();
        newRecord.find('.remote-subnets').append(
            '<input type="text" data-name="advanced_settings[s2s_ipsec][remote_sites][' + newRecordNum + '][' + baseName + ']" name="' + newName + '" class="edit_field size_long js-remote-subnets-tokenfield"' +
            '<div class="clear_left"></div>');
      }
    });
    $editForm.find('#s2sipsec-remote-sites').append(newRecord);
    const tokenfieldSelector = `.js-remote-subnets-tokenfield[name="remote_subnets[${newRecordNum}]"]`;
    createTokenField(tokenfieldSelector, [], `remote_subnets[${newRecordNum}]`, data.subnetsLimit, $editForm[0]);
    addRemoteIdToggleHandler($editForm.find('.ipsec-content:last'));
    newRecord.find('.js-delete-site').click(onRemoteSiteDeleteClick);
    addPublicIpChanges(newRecord, newRecordNum);
    $(`<div class="text-muted">${data.maxSubnetsTip}</div>`).insertAfter(newRecord.find('.tokenfield.tokenfield-mode-tokens'));

    newRecord.find('[value=ip]').trigger('click');
    toggleAddNewRemoteSiteButtonVisibility();
  };

  initFields();

  $editForm.find('.local-id [type=radio]').click(function() {
    const $this = $(this);
    $this.parents('[local-id]').attr('local-id', this.value);

    const $localIdBlock = $this.parents('.local-id'),
        $localIpInput = $localIdBlock.find('.js-local-ip'),
        $localNameInput = $localIdBlock.find('.js-local-name');
    if (this.value === 'ip') {
      if (!data.stayLocalIpDisabledIfSelected) {
        $localIpInput.prop('disabled', false);
      }
      $localNameInput.prop('disabled', true);
    } else {
      $localNameInput.prop('disabled', false);
      $localIpInput.prop('disabled', true);
    }
  });

  addRemoteIdToggleHandler($editForm.find('#s2sipsec-remote-sites'));
  $editForm.find('.ipsec-site.record .js-delete-site').click(onRemoteSiteDeleteClick);
  toggleDeleteSiteButtonVisibility();

  toggleAddNewRemoteSiteButtonVisibility();
  $addRemoteSiteButton.click(function() {
    addNewSite();
    toggleDeleteSiteButtonVisibility();
  });

  $editForm.validate();

  emulateCheck('ipsec_state');
};

export {initS2SIPSec, createTokenField}
